import './css/base.css'
import Shikwasa from './player'

export default Shikwasa
/** CONSOLE_MSG */

